import { ColDef, GridReadyEvent } from 'ag-grid-community'
import InfinityAgGrid from 'components/table/InfinityAgGrid'
import { UIModal } from 'features/UI'
import { SyntheticEvent, useMemo, useState } from 'react'
import { Question } from 'types'

export function QueryQuestionsCell({ questions }: { questions: Question[] }) {
  const [isOpen, setIsOpen] = useState(false)

  const handleOpen = (event: SyntheticEvent) => {
    event.preventDefault()
    setIsOpen(true)
  }

  const handleClose = () => {
    setIsOpen(false)
  }

  const handleGridReady = (event: GridReadyEvent) => {
    event.api.sizeColumnsToFit()
  }

  const columnDefs: ColDef[] = useMemo(() => {
    return [
      {
        headerName: 'Name',
        field: 'name',
      },
    ]
  }, [])

  return (
    <div>
      <a href="" onClick={handleOpen}>
        {questions.length}
      </a>

      <UIModal isOpen={isOpen} onClose={handleClose} width={648} title="Questions">
        <div
          className="ag-theme-alpine"
          style={{ height: '400px', width: '600px', fontSize: '1rem' }}
        >
          <InfinityAgGrid
            rowData={questions}
            columnDefs={columnDefs}
            rowModelType="clientSide"
            onGridReady={handleGridReady}
            floatingFiltersHeight={0}
          />
        </div>
      </UIModal>
    </div>
  )
}
